import { render, staticRenderFns } from "./ManageApplications.vue?vue&type=template&id=bf5986fe&scoped=true&lang=pug"
import script from "./ManageApplications.vue?vue&type=script&lang=js"
export * from "./ManageApplications.vue?vue&type=script&lang=js"
import style0 from "./ManageApplications.vue?vue&type=style&index=0&id=bf5986fe&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5986fe",
  null
  
)

export default component.exports